/**
 * GET /v1/system/sync-jobs/:syncJobPublicId
 *
 * One sync job, as the job detail dialog shows it. Mirrors the response the
 * backend's `get-single` use-case builds: `schoolId`, `schoolName` and
 * `syncConfigId` are null when the job has no school or config, the timestamps
 * are ISO strings, and `metadata` is the job's free-form JSON, shown raw.
 */

import { z } from 'zod'

export const SyncJobDetailSchema = z.object({
  id: z.string(),
  schoolId: z.string().nullable().optional(),
  schoolName: z.string().nullable().optional(),
  syncType: z.string(),
  syncConfigId: z.string().nullable().optional(),
  status: z.string(),
  priority: z.string().optional(),
  queuedAt: z.string().nullable().optional(),
  startedAt: z.string().nullable().optional(),
  completedAt: z.string().nullable().optional(),
  error: z.string().nullable().optional(),
  lastSyncedItemId: z.string().nullable().optional(),
  lastSyncedItemDate: z.string().nullable().optional(),
  totalItemsProcessed: z.number().optional(),
  totalNewItems: z.number().optional(),
  totalUpdatedItems: z.number().optional(),
  totalFailedItems: z.number().optional(),
  totalErrorItems: z.number().optional(),
  nextPageToken: z.string().nullable().optional(),
  metadata: z
    .looseObject({ failedItems: z.array(z.unknown()).optional() })
    .nullable()
    .optional(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional()
})

export type SyncJobDetail = z.infer<typeof SyncJobDetailSchema>

export const GetSyncJobResponseSchema = z.object({
  message: z.string().optional(),
  data: SyncJobDetailSchema
})

export type GetSyncJobResponse = z.infer<typeof GetSyncJobResponseSchema>
